import desktopTourHotConfig from '../config/desktopTourHot';
import desktopTourSearchConfig from '../config/desktopTourSearch';
import mobileTourHotConfig from '../config/mobileTourHot';
import mobileTourSearchConfig from '../config/mobileTourSearch';
import createTourBannerSlotsGetter from './createTourBannerSlotsGetter';

const DESKTOP_GRID = { anchorWithA51: 7, anchorWithCashback: 5, anchorWithout: 3, step: 3 } as const;
const MOBILE_GRID  = { anchorWithA51: 9, anchorWithCashback: 5, anchorWithout: 5, step: 5 } as const;

export const getDesktopTourSearchBannerSlots = createTourBannerSlotsGetter({ config: desktopTourSearchConfig, ...DESKTOP_GRID });
export const getDesktopTourHotBannerSlots    = createTourBannerSlotsGetter({ config: desktopTourHotConfig,    ...DESKTOP_GRID });
export const getMobileTourSearchBannerSlots  = createTourBannerSlotsGetter({ config: mobileTourSearchConfig,  ...MOBILE_GRID });
export const getMobileTourHotBannerSlots     = createTourBannerSlotsGetter({ config: mobileTourHotConfig,     ...MOBILE_GRID });
